@if (displayChatButton) {
  <button class="td-wb-chat__button"
          id="td-wb-chat-button"
          [attr.aria-label]="'tdWb.chat.CHAT' | translate"
          tdWbButton
          tdWbBlock="spinningWheel"
          [tdWbOverlayToggle]="overlayTemplate"
          tdWbOverlayPosition="end-top"
          [tdWbOverlayAsync]="true"
          (tdWbOverlayAsyncOpen)="asyncOpen($event)"
          [disabled]="loading"
          (click)="openChat()">
    <td-wb-icon size="24"
                iconId="chat"
                class="td-wb-chat__icon" />
  </button>
}

<ng-template #overlayTemplate>
  <td-wb-overlay class="td-wb-chat-overlay"
                 aria-labelledby="overlay-title">
    <td-wb-overlay-header>
      <span class="td-wb-chat-overlay__header"
            translate="tdWb.chat.OVERLAY_HEADER"></span>
    </td-wb-overlay-header>
    <span class="td-wb-chat-overlay__body"
          translate="tdWb.chat.OVERLAY_BODY"></span>
  </td-wb-overlay>
</ng-template>
